import { Menu, usePermissions } from "react-admin";
import { hasPermission, type Permission } from "../auth/HasPermission";

// Resource menu items are gated by registering only permitted resources in App.tsx
// (so Menu.ResourceItems renders only those); the dashboard item is gated here
// by `dashboard.view` (BR-AC-04).
export function AppMenu() {
  const { permissions } = usePermissions<Permission[]>();
  return (
    <Menu>
      {hasPermission(permissions, "dashboard.view") && <Menu.DashboardItem />}
      <Menu.ResourceItems />
    </Menu>
  );
}
